export default __webpack_public_path__ + "static/media/957.b9459619.png";